<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{$t('portfolio.title')}}
        <Bookmark service_type_code='6434' />
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('portfolio.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.list') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">

          <div class="top__component__fold__wrap" v-if="component_fold">
            <!-- 상단 검색 영역 : S -->
            <v-row class="top_search_content2">
              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myapplication.fields.application') }}</label>
                <v-select
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type1"
                  :items="$vuetify.rtl ? applicationTypeCodeArList : applicationTypeCodeEnList"
                  v-model="search.search_application_type_code"
                  @change="fnGetStatusCodeList()"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type1"
                  :items="$vuetify.rtl ? statusCodeListAr : statusCodeListEn"
                  v-model="search.search_application_status_seq"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myapplication.fields.applicant') }}</label>
                <v-text-field
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type5"
                  v-model="search.search_applicant"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row class="top_search_content2">
              <v-col cols="12" md="4">
                <v-select
                  dense
                  solo
                  flat
                  outlined
                  hide-details
                  class="type2"
                  :items="dateTypeList"
                  v-model="search.search_date"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="8" class="d-flex align-center mobile__dcolumn">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      flat
                      solo
                      dense
                      outlined
                      readonly
                      hide-details
                      v-on="on"
                      v-bind="attrs"
                      v-model="viewDate1"
                      @click:append="menu1 = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date1" @input="fnSetStartDate()"></v-date-picker>
                </v-menu>
                <v-spacer class="hidden_lr10 text-center">~</v-spacer>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      flat
                      solo
                      dense
                      outlined
                      readonly
                      hide-details
                      v-on="on"
                      v-bind="attrs"
                      v-model="viewDate2"
                      @click:append="menu2 = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker :min="date1" v-model="date2" @input="fnSetEndDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="top_search_content2 wt_type2">
              <v-col cols="12" md="4">
                <v-select
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type2"
                  style="background:#fbf3f4"
                  :items="keyList"
                  v-model="search.search_key"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  flat
                  dense
                  hide-details
                  outlined
                  class="type5"
                  v-model="search.search_keyword"
                >
                </v-text-field>

              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">
                  {{ $t('myapplication.fields.title') }}
                </label>
                <v-text-field
                  solo
                  flat
                  dense
                  hide-details
                  outlined
                  v-model="search.search_title"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row class="top_search_content2">
              <v-col cols="12" md="8">
                <label class="nec_title">{{ $t('myapplication.fields.applicant_type') }}</label>
                <v-select
                  solo
                  flat
                  dense
                  hide-details
                  outlined
                  :items="$vuetify.rtl ? applicantTypeCodeArList : applicantTypeCodeEnList"
                  v-model="search.search_applicant_type_code"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4" class="mobile__dcolumn">
                <v-btn class="t_search_btn wp50" color="#a01c2a" dense dark @click="fnGetPortfolioList()">
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                <v-btn class="t_search_btn wp50" color="#222" dense dark @click="fnReset()">
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>

            <!-- 상단 검색 영역 : E -->
          </div>

          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->



          <v-row class="mt-25">
            <v-col cols="12">
              <div class="data_table_html_type">
                <v-data-table
                  :headers="$getHeaderType1(headerTxt, headers)"
                  :items="portfolioList"
                  class="elevation-0 myapp_table_type2 type4"
                  hide-default-footer
                  :page.sync="paging.page"
                  :items-per-page="paging.pageSize"
                  :mobile-breakpoint="MobileBreakPoint"
                  @page-count="paging.pageCount = $event"
                  @click:row="fnGoDetail"
                >
                  <template v-slot:item.application_count="{ item }">
                    <div class="d-flex align-center justify-center">
                      <span>{{ item.application_count }}</span>
                      <v-spacer class="hidden_lr2"></v-spacer>
                      <v-btn
                        icon
                      >
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </div>

                  </template>
                </v-data-table>

                <div class="v-data-table-footer page_nation_wrap mt-20">
                  <pagination :paging.sync="paging" />
                </div>

              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex">
              <v-spacer></v-spacer>
              <v-btn
                dense
                dark
                height="50"
                width="150"
                color="#a01c2a"
                class="capitalize br_none ft-size12"
                @click="compnonent_dialog = true"
              >
                {{ $t('common.button.new') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-dialog
      v-model="compnonent_dialog"
      flat
      persistent
      max-width="700"
      content-class="br_none"
    >
      <v-card class="br_none modal_comfirm_wrap type4">
        <v-btn class="modal_close" @click="compnonent_dialog = false" fab color="white">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <h2 class="header_title02">{{ $t('portfolio.new_title') }}</h2>
      </v-card>
      <v-layout class="type2 modal_type pa-25 pt-0" style="background-color: #FFF;">

        <v-flex class="pa-0 login_content type2">
          <ValidationObserver ref="observer">
            <v-form>
              <v-row class="d-flex align-center wp100">
                <v-col cols="3">
                  <h2 class="nec_title"><i>*</i> {{ $t('portfolio.fields.portfolio_name') }}</h2>
                </v-col>
                <v-col cols="9">
                  <div class="input_text_type_basic wp100">
                    <ValidationProvider v-slot="{ errors }" :name="$t('portfolio.fields.portfolio_name')" :rules="{required: true}">
                    <v-text-field
                      placeholder=""
                      dense
                      outlined
                      hide-details
                      clearable
                      class="ft-size12"
                      v-model="subject"
                      :error-messages="errors"
                    >
                    </v-text-field>
                    </ValidationProvider>
                  </div>
                </v-col>
              </v-row>

              <v-row class="d-flex wp100">
                <v-col cols="3">
                  <h2 class="nec_title">{{ $t('portfolio.fields.description') }}</h2>
                </v-col>
                <v-col cols="9">
                  <div class="input_text_type_basic wp100">
                    <v-textarea
                      placeholder=""
                      dense
                      outlined
                      hide-details
                      class="ft-size12"
                      v-model="description"
                    >
                    </v-textarea>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
          <v-row class="wp100">
            <v-col cols="12" class="d-flex">
              <v-spacer></v-spacer>
              <v-btn
                dense
                height="50"
                width="150"
                dark
                color="#a01c2a"
                class="capitalize btn_basic"
                @click.stop="fnSave()"
              >
                {{ $t('common.button.save') }}
              </v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-dialog>

  </v-container>
</template>

<script>
import Pagination from '@/components/layout/Pagination'
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Bookmark from '@/components/layout/Bookmark'

export default {
  components :{
    Pagination,
    ValidationObserver,
    ValidationProvider,
    Bookmark
  },
  data () {
    return {
      component_fold:false,
      MobileBreakPoint:0,
      headerTxt : {
        prefix : 'portfolio.fields.',
        txt : [ 'portfolio_name','no_of_applications']
      },

      headers: [
        { text: '', align: 'center', value : 'subject', width:550},
        { text: '', align: 'center', value : 'application_count', width:100 }
      ],

      portfolioList : [],

      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },

      search : {
        search_application_type_code : '',
        search_date : 'grant_date',
        search_start_date : '',
        search_end_date : '',
        search_key : 'application_no',
        search_keyword : '',
        search_applicant : '',
        search_title : '',
        search_applicant_type_code : '',
        search_application_status_seq : ''
      },

      applicationTypeCodeArList : [],
      applicationTypeCodeEnList : [],

      applicantTypeCodeArList : [],
      applicantTypeCodeEnList : [],

      menu1: false,
      menu2: false,
      date1 : null,
      date2 : null,
      viewDate1 : '',
      viewDate2 : '',

      statusCodeListAr : [
        { value : '', text : 'جميع'}
      ],
      statusCodeListEn : [
        { value : '', text : 'All'}
      ],

      compnonent_dialog : false,

      subject : '',
      description : ''
    }
  },
  computed: {
    dateTypeList () {
      let list = [
        {value : 'grant_date', text : this.$t('portfolio.fields.grant_date')},
        {value : 'filing_date', text : this.$t('portfolio.fields.filing_date')}
      ]
      return list
    },
    keyList () {
      let list = [
        {value : 'application_no', text : this.$t('portfolio.fields.application_no')},
        {value : 'grant_no', text : this.$t('portfolio.fields.grant_no')},
        {value : 'pct_application_no', text : this.$t('portfolio.fields.pct_application_no')},
      ]
      return list
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })


    //넘겨받은 쿼리스트링을 검색 파라메터에 삽입
    let param = utils.qryStrToJson(location.href)
    if(param){
      this.search = param

      this.date1 = this.formatDate2(this.search.search_start_date)
      this.date2 = this.formatDate2(this.search.search_end_date)
      this.viewDate1 = this.search.search_start_date
      this.viewDate2 = this.search.search_end_date
    }
    this.fnGetStatusCodeList()
    this.fnInit()
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    fnInit(){
      let options = {
        upper_code: '8910',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.applicationTypeCodeEnList = list.en
        this.applicationTypeCodeArList = list.ar
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      options = {
        upper_code: '2700',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.applicantTypeCodeEnList = list.en
        this.applicantTypeCodeArList = list.ar
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      this.user_seq = store.state.token.user_seq

      this.fnGetPortfolioList()
    },

    fnGetPortfolioList(){
      requestApi({
        url: '/users/portfolios',
        method: 'GET',
        data : this.search,
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }

            this.portfolioList = res.data.list
            this.paging.totalCount = res.data.list.length
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPortfolioList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnReset(){
      //파라미터 초기화
      this.search.search_application_type_code = ''
      this.search.search_date = 'grant_date'
      this.search.search_start_date = ''
      this.search.search_end_date = ''
      this.search.search_key = 'application_no'
      this.search.search_keyword = ''
      this.search.search_applicant = ''
      this.search.search_title = ''
      this.search.search_applicant_type_code = ''

      let listAr = [
        { value : '', text : 'جميع'}
      ]
      let listEn = [
        { value : '', text : 'All'}
      ]
      this.statusCodeListAr = listAr
      this.statusCodeListEn = listEn
      this.search.search_application_status_seq = ''

      // 페이징
      this.paging.page = 1

      // 달력 초기화
      this.date1 = null
      this.date2 = null
      this.viewDate1 = ''
      this.viewDate2 = ''

      this.fnGetPortfolioList()
    },

    fnSetStartDate(){
      this.viewDate1 = this.formatViewDate(this.date1)
      this.menu1 = false
      // 저장객체에 날짜 세팅
      this.search.search_start_date = this.formatDate(this.date1)

      this.fnSetMinDate()
    },
    fnSetEndDate(){
      this.viewDate2 = this.formatViewDate(this.date2)
      this.menu2 = false
      // 저장객체에 날짜 세팅
      this.search.search_end_date = this.formatDate(this.date2)
    },
    fnSetMinDate(){
      if(!utils.isNull(this.date2)){
        let start = this.date1.split('-')
        let end   = this.date2.split('-')

        let startDate = new Date()
        startDate.setFullYear(start[0])
        startDate.setMonth(Number(start[1]) - 1)
        startDate.setDate(start[2])

        let endDate = new Date()
        endDate.setFullYear(end[0])
        endDate.setMonth(Number(end[1]) - 1)
        endDate.setDate(end[2])

        if(endDate < startDate){
          this.date2 = this.date1
          this.viewDate2 = this.formatViewDate(this.date1)
          this.saerch.search_end_date = this.formatDate(this.date1)
        }
      }
    },
    formatViewDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    formatDate2 (date) {
      if (!date) return ''
      const [day, month, year] = date.split('-')
      return `${year}-${month}-${day}`
    },
    fnIsNull(val){
      return utils.isNull(val)
    },
    fnGetStatusCodeList(){

      let search_application_status_seq = this.search.search_application_status_seq
      this.search.search_application_status_seq = ''

      if(this.search.search_application_type_code == ''){
        this.statusCodeListAr = [{ text : 'جميع', value : "" }]
        this.statusCodeListEn = [{ text : 'All', value : '' }]
        this.search.search_application_status_seq = ''
      }else{
        requestApi({
          url: '/workflow/' + this.search.search_application_type_code + '/status',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {

              this.statusCodeListAr = [{ text : 'جميع', value : '' }]
              this.statusCodeListEn = [{ text : 'All', value : '' }]

              for (let i = 0; i < res.data.list.length; i++) {

                let item = res.data.list[i]
                let statusEnItem = {
                  text : item.name_en,
                  value : item.seq
                }
                this.statusCodeListEn.push( statusEnItem )

                let statusArItem = {
                  text : item.name_ar,
                  value : item.seq
                }
                this.statusCodeListAr.push( statusArItem )

                if( item.seq == search_application_status_seq ){
                  this.search.search_application_status_seq = item.seq
                }
              }

            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetStatusCodeList()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnSave(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){

          let params = {
            subject : this.subject,
            description : this.description
          }

          requestApi({
            url: '/users/portfolio',
            method: 'POST',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let option = {
                  text : this.$t('common.message.add.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', option)

                this.subject = ''
                this.description = ''
                this.compnonent_dialog = false

                this.$refs.observer.reset()
                this.fnGetPortfolioList()

              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSave()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },

    fnGoDetail(item){
      let qryStr = utils.jsonToQryStr(this.search)
      let url = "/portfolio/" + item.seq + "/view/" + qryStr
      this.$router.push(url)
    },

    getColor (colorbadge) {
        if (colorbadge === 'Important') return '#b22325'
        else if (colorbadge === 'Warning') return '#f59a41'
        else if (colorbadge === 'Inactive') return '#c1c1c1'
        else if (colorbadge === 'Active') return '#99bc44'
        else if (colorbadge === 'Success') return '#00af50'
        else if (colorbadge === 'In Progress') return '#333'
        else if (colorbadge === 'Complete') return '#2a58ad'
        else if (colorbadge === 'Failure') return '#c1c1c1'
        else if (colorbadge === 'claim') return '#a01c2a'
        else if (colorbadge === 'smd') return '#a2c1e2'
        else if (colorbadge === 'pay') return '#98bbbf'

        else return '#1f94a6'
    }
  },
}
</script>